export function save(fetch, dados) {
  return fetch().post(`/venda/inserir`, { venda: dados });
}

export function get(fetch, filtros) {
  return fetch().post("/prevenda/get", filtros);
}

export function getById(fetch, id) {
  return fetch().post("/prevenda/get/" + id);
}

export function recuperar(fetch, id) {
  return fetch().post("/prevenda/recuperar/" + id);
}

export function Delete(fetch, id) {
  return fetch().post("/prevenda/cancelar", { id, motivo: "can" });
}

